import React from 'react';
import { faCarWrench } from '@fortawesome/pro-regular-svg-icons/faCarWrench';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CarWrenchRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCarWrench} {...props} />;
}
